import * as React from 'react';
import type { SVGProps } from 'react';
const SvgScoringMinus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    aria-label="ScoringMinus"
    viewBox="0 0 16 16"
    {...props}
  >
    <path d="M4.376 8a.6.6 0 0 1 .6-.6h6.048a.6.6 0 1 1 0 1.2H4.976a.6.6 0 0 1-.6-.6" />
  </svg>
);
export default SvgScoringMinus;
